import apiFn from 'common/services/api-service';

import { CONF_DEPENDENT_FIELDS } from './constants';

// Recursively check if all dependencies of this config are enabled
export const areDependenciesEnabled = (baseKey, data) => {
  const dependencyKey = CONF_DEPENDENT_FIELDS[baseKey];
  if (!dependencyKey) {
    return true;
  }

  if (Array.isArray(dependencyKey)) {
    return dependencyKey.every(key => data[key]?.value && areDependenciesEnabled(key, data));
  }

  return data[dependencyKey]?.value && areDependenciesEnabled(dependencyKey, data);
};

export function updateCode(payload) {
  return apiFn('/api/cms/v1/change-event-shortcode')
    .post(null, payload)
    .then(response => response.data.data);
}
